import { render, staticRenderFns } from "./PaymentsReport.vue?vue&type=template&id=7fb59cdb"
import script from "./PaymentsReport.vue?vue&type=script&lang=ts"
export * from "./PaymentsReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports